export default __webpack_public_path__ + "static/media/product_12.1980e6a0.png";